<template>
  <div class="card-list-data">
    <InputField :is-required="true" :label="$t('quick_booking.lbl_first_name')" :placeholder="$t('customer.first_name')" v-model="first_name" :error-message="errors.first_name" :error-messages="errorMessages['first_name']"></InputField>

    <div class="form-group">
      <label class="form-label">{{ $t('quick_booking.lbl_phone_number') }}<span class="text-danger">*</span> </label>
      <vue-tel-input :value="mobile" @input="handleInput" v-bind="{ mode: 'international', maxLen: 15, defaultCountry: defaultCountry, autoDefaultCountry: false, inputOptions: { placeholder: t('quick_booking.ph_phone_number') } }"></vue-tel-input>
      <span class="text-danger">{{ errors['mobile'] }}</span>
    </div>

    <div v-if="store.errorMessage" class="alert alert-danger mt-3">
      {{ store.errorMessage }}
    </div>
  </div>
  <div class="card-footer">
    <button type="button" class="btn btn-secondary iq-text-uppercase" v-if="wizardPrev" @click="prevTabChange(wizardPrev)">{{ $t('quick_booking.lbl_back') }}</button>
    <button :disabled="IS_SUBMITED" class="btn btn-primary iq-text-uppercase" name="submit" v-if="wizardNext" @click="formSubmit">
      <template v-if="IS_SUBMITED">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ $t('quick_booking.lbl_loading') }}
      </template>
      <template v-else> {{ $t('quick_booking.lbl_submit') }}</template>
    </button>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useField, useForm } from 'vee-validate'
import { VueTelInput } from 'vue3-tel-input'
import InputField from '@/vue/components/form-elements/InputField.vue'
import * as yup from 'yup'
import { useQuickBooking } from '../../store/quick-booking'
// Without this the widget IP-detects the country and lands on the wrong dial code.
const defaultCountry = (typeof window !== 'undefined' && window.QB_DEFAULT_COUNTRY) || 'bg'

// The validation messages below were hard-coded English and surfaced as such on
// the Bulgarian page, so they come from the translation file like everything else.
const { t } = useI18n()

const props = defineProps({
  wizardNext: {
    default: '',
    type: [String, Number]
  },
  wizardPrev: {
    default: '',
    type: [String, Number]
  }
})
/*
 * Form Data & Validation & Handeling
 */
// Default FORM DATA
const defaultData = () => {
  errorMessages.value = {}
  return {
    first_name: '',
    mobile: ''
  }
}

const numberRegex = /^\d+$/
const validationSchema = yup.object({
  first_name: yup
    .string()
    .required(t('quick_booking.msg_first_name_required'))
    .test('is-string', t('quick_booking.msg_first_name_invalid'), (value) => {
      // Regular expressions to disallow special characters and numbers
      const specialCharsRegex = /[!@#$%^&*(),.?":{}|<>\-_;'\/+=\[\]\\]/
      return !specialCharsRegex.test(value) && !numberRegex.test(value)
    }),
  mobile: yup
    .string()
    .required(t('quick_booking.msg_phone_required'))
    .matches(/^(\+?\d+)?(\s?\d+)*$/, t('quick_booking.msg_phone_invalid'))
})

const { handleSubmit, errors, resetForm } = useForm({
  validationSchema
})
const { value: first_name } = useField('first_name')
const { value: mobile } = useField('mobile')
const errorMessages = ref({})
const IS_SUBMITED = ref(false)

// phone number
const handleInput = (phone, phoneObject) => {
  // Handle the input event
  if (phoneObject?.formatted) {
    mobile.value = phoneObject.formatted
  }
}

// Form Submit
const emit = defineEmits(['tab-change', 'onReset'])
const prevTabChange = (val) => emit('tab-change', val)
const formSubmit = handleSubmit((values) => {
  IS_SUBMITED.value = true
  emit('tab-change', props.wizardNext)
})
const store = useQuickBooking()
resetForm(defaultData())

watch(
  () => store.bookingResponse,
  (value) => {
    IS_SUBMITED.value = false
    resetForm(defaultData())
  },
  { deep: true }
)

watch(
  () => store.errorMessage,
  (value) => {
    if (value) {
      IS_SUBMITED.value = false
    }
  }
)

watch(
  () => mobile.value,
  (value) => {
    store.updateUserValues({ key: 'mobile', value: value })
  },
  { deep: true }
)

watch(
  () => first_name.value,
  (value) => {
    store.updateUserValues({ key: 'first_name', value: value })
  },
  { deep: true }
)
</script>
